import { getPanelCardText } from './frontendConfigMerge';

/** Texto de tarjeta de panel: config bilingüe + claves i18n de respaldo. */
const STALE_D28D_GALLERY_TITLES = new Set([
  'Galería de clases',
  'GALERÍA DE CLASES',
  'Class gallery',
  'CLASS GALLERY',
]);
const STALE_D28D_GALLERY_DESCS = new Set([
  'Grabaciones y URLs de clases en vivo ya realizadas.',
  'Grabaciones y enlaces de clases en vivo ya realizadas.',
  'Recordings and links from past live classes.',
]);

export function panelCardText(t, config, panelId, cardId, field, lang) {
  const key = `panel.${panelId}.cards.${cardId}.${field}`;
  const i18nFallback = t(key, '');
  const fromConfig = getPanelCardText(config, panelId, cardId, field, lang, t, key);
  if (cardId === 'd28d-gallery' && i18nFallback) {
    if (field === 'title' && (!fromConfig || STALE_D28D_GALLERY_TITLES.has(String(fromConfig).trim()))) {
      return i18nFallback;
    }
    if (field === 'desc' && (!fromConfig || STALE_D28D_GALLERY_DESCS.has(String(fromConfig).trim()))) {
      return i18nFallback;
    }
  }
  return fromConfig || i18nFallback;
}
